import Body from './Body';
import './home.css'
import Header from './Header';

function Home() {
  return (
    <div className="App">
      <Header />
      <Body />
    </div>
  );
}

export default Home;
